import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Fade from '@mui/material/Fade';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Table from 'Components/UI/Table';
import LoadMoreButton from 'Components/UI/Table/LoadMoreButton';

const styles = () => ({
  root: {},
  tablePagination: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
});

const StatementsTaxDocsTableView = ({
  className,
  classes,
  type,
  columns,
  data,
  LoadMoreButtonProps,
}) => {
  return (
    <Fade
      in
      timeout={500}
    >
      <div className={classNames(classes.root, className)}>
        <Table
          title={type}
          columns={columns}
          data={data}
          PlaceholderMessageProps={{
            message: `This account has no ${type.toLowerCase()}.`,
            test: `managed-account-docs-${type.toLowerCase()}-table-placeholder`,
          }}
          test={`managed-account-${type.toLowerCase()}-table`}
        />
        {data.length >= 1 && (
          <LoadMoreButton
            {...LoadMoreButtonProps}
          />)
        }
      </div>
    </Fade>
  );
};

StatementsTaxDocsTableView.defaultProps = {
  className: '',
};

StatementsTaxDocsTableView.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  LoadMoreButtonProps: PropTypes.object.isRequired,
};

export default withStyles(styles)(StatementsTaxDocsTableView);
